import React from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import $ from 'jquery';
const StickySocial = () => {
   $(function(){
    //Scroll event
    $(window).on('scroll', function(){
      var scrolled = $(window).scrollTop();
      if (scrolled > 100) $('.sticky-head-cls').fadeIn('slow');
      if (scrolled < 100) $('.sticky-head-cls').fadeOut('slow');
    });  
  });
  return (
    <>
        <div className="sticky-head-cls">
          <div className="sticky-icon">
            <a target="_blank" href="https://www.facebook.com/AlobhaTechnology/"
              className="st-Facebook" >
              <i className="fa fa-facebook"> </i> Facebook{" "}
            </a>
            <a
              target="_blank"
              href="https://twitter.com/AlobhaTech"
              className="st-Twitter"
            >
              <i className="fa fa-twitter"> </i>
              Twitter{" "}
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/alobha-technologies"
              className="st-Linkedin"
            >
              <i className="fa fa-linkedin"> </i> Linkedin
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/alobha_technologies/"
              className="st-Instagram"
            >
              <i className="fa fa-instagram" /> Instagram
            </a>
            <a target="_blank" href="https://www.youtube.com/@alobhatechnologies1722" className="st-Youtube" >
              <i className="fa fa-youtube" /> Youtube
            </a>
          </div>
        </div>
    </>
  )
}

export default StickySocial